/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import { Flex } from "..";
import { Label } from "../Label";
import { Checkbox } from "./Checkbox";
import { CheckboxHelperText } from "./Checkbox.helperText";
import { CheckboxLabel } from "./Checkbox.label";
import type { CheckboxSetProps } from "./Checkbox.types";
import { CheckboxGroup } from "./CheckboxGroup";

const CheckboxSet = ({ children, sx }: CheckboxSetProps) => {
  return (
    <Flex.Column
      gap={vars.spacing[1]}
      sx={{
        '&:has([data-checkbox-icon_position="left"]) [data-checkbox-helper_text]': {
          paddingInlineStart: vars.spacing[6],
        },
        "&:has(input:disabled) [data-checkbox-helper_text]": {
          color: vars.semantic.color.textDisabled,
        },
        "& [data-checkbox-helper_text]": {
          color: vars.semantic.color.textSecondary,
        },
        ...sx,
      }}
    >
      {children}
    </Flex.Column>
  );
};

const CheckboxNamespace = Object.assign(Checkbox, {
  Set: CheckboxSet,
  Group: CheckboxGroup,
  Label: CheckboxLabel,
  HelperText: CheckboxHelperText,
  Legend: Label,
});

export { CheckboxNamespace as Checkbox };
